import { Reducer } from "@reduxjs/toolkit";
import { AuthTypes, AuthState, Auth } from "./types";

import { clearSession } from "../../../config/cookies";

const INITIAL_AUTH: Auth = {
  authorized: false,
};

const INITIAL_STATE: AuthState = {
  data: INITIAL_AUTH,
  error: false,
  errorMessage: null,
  loading: false,
};

const reducer: Reducer<AuthState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case AuthTypes.AUTH_LOGIN:
      return {
        ...state,
        error: false,
        errorMessage: null,
        loading: false,
        data: {
          ...state.data,
          ...action.payload.data,
          authorized: true,
        },
      };
    case AuthTypes.AUTH_LOGIN_REQUEST:
      return { ...state, loading: true, error: false };

    case AuthTypes.AUTH_LOGIN_REQUEST_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        errorMessage: null,
        data: {
          ...state.data,
          ...action.payload.data,
        },
      };

    case AuthTypes.AUTH_LOGIN_REQUEST_FAILURE:
      const err = action.payload.err;
      const normalizedError = err?.response
        ? {
            message: err.response.data || "Erro no servidor",
            status: err.response.status,
            data: err.response.data,
          }
        : {
            message: err?.message || err?.toString() || "Erro desconhecido",
          };

      return {
        ...state,
        loading: false,
        error: true,
        errorMessage: normalizedError,
        data: INITIAL_AUTH,
    };

    case AuthTypes.REFRESH_TOKEN:
      return { ...state, loading: true, error: false };

    case AuthTypes.REFRESH_TOKEN_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        errorMessage: null,
        data: {
          ...state.data,
          ...action.payload.data,
        },
      };

    case AuthTypes.REFRESH_TOKEN_FAILURE:
      clearSession();
      return {
        ...state,
        loading: false,
        error: false,
        errorMessage: null,
        data: INITIAL_AUTH,
      };

    case AuthTypes.AUTH_LOGOUT:
      return { ...state, loading: true, error: false };

    case AuthTypes.AUTH_EMAIL_UPDATED:
      return {
        ...state,
        data: state.data
          ? { ...state.data, emailUsuario: action.payload.email }
          : state.data,
      };

    case AuthTypes.AUTH_PHOTO_UPDATED:
      return {
        ...state,
        data: state.data
          ? { ...state.data, imgUsuario: action.payload.imgUsuario }
          : state.data,
      };

    case AuthTypes.AUTH_LOGOUT_SUCCESS:
      clearSession();
      return {
        ...state,
        loading: false,
        error: false,
        errorMessage: null,
        data: INITIAL_AUTH,
      };

    case AuthTypes.AUTH_LOGOUT_FAILURE:
      clearSession();
      return {
        ...state,
        loading: false,
        error: false,
        errorMessage: null,
        data: INITIAL_AUTH,
      };

    default:
      return state;
  }
};

export default reducer;
